import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[appKanbanGrid]'
  })
export class KanbanBoardDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }
}
